module.exports = __webpack_public_path__ + "static/media/web-app-dev.7c0f697f.jpg";